/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodeX = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 21H4.254c-.442-.605-.831-1.39-1.17-2.354s-.603-2.023-.795-3.176a21.041 21.041 0 0 1 0-6.949c.192-1.147.457-2.206.796-3.176.338-.971.727-1.753 1.169-2.345H6c-.695 1.16-1.235 2.527-1.62 4.103S3.803 10.31 3.803 12s.192 3.321.577 4.897C4.765 18.473 5.305 19.84 6 21zm.5-4 4.408-5.263-2.356-4.731h2.47l1.52 3.382 2.717-3.382h2.508l-4.161 4.921L16.152 17h-2.394l-1.767-3.705L9.027 17zm13.246 4H18c.695-1.16 1.235-2.527 1.62-4.103.385-1.576.577-3.208.577-4.897s-.192-3.321-.577-4.897C19.235 5.527 18.695 4.16 18 3h1.746c.442.592.831 1.374 1.17 2.345.338.97.603 2.029.795 3.176a21.037 21.037 0 0 1 0 6.949 19.115 19.115 0 0 1-.796 3.176c-.338.964-.727 1.749-1.169 2.354z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCodeX as CodeX };
